<template>
  <div class="main">
    <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
      <div class="actions">
        <h3 style="font-size: 28px; line-height: 45px">Sales By Items</h3>
      </div>
      <div>
        <div class="card-container">
          <div class="requestActions">
            <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
            <div class="mx-4 pt-1">
              <a-range-picker @change="onCategoryChange"></a-range-picker>
            </div>

            <a-button @click="exportExcell" style="
              width: 159px;
              height: 38px;
              margin-right: 10px;
              border-raduis: 5px;
              background: #418a49;
              color: #fff;
            " icon="export">
              Export
            </a-button>
            <!-- <a-button @click="showAddNewOrderPage" style="height:38px; border-raduis:5px; background: #ffffff" icon="plus">
                            Request for Inventory
                        </a-button> -->
          </div>
          <a-row>
            <a-col :span="24">
              <a-table :columns="columns" :data-source="productData" :loading="tableLoading"
                :pagination="{ pageSize: 20 }" class="tableStyle">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                  style="padding: 8px">
                  <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                  <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                    Search
                  </a-button>
                  <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                    Reset
                  </a-button>
                </div>
                <div slot="filterCategoryDropdown"
                  slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                  <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                  <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                    Search
                  </a-button>
                  <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                    Reset
                  </a-button>
                </div>

                <div slot="filterSupplierDropdown"
                  slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                  <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                  <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                    Search
                  </a-button>
                  <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                    Reset
                  </a-button>
                </div>
                <template slot="action" slot-scope="data">
                  <a-dropdown>
                    <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                      <a-icon style="font-size: 25px" type="ellipsis" />
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="showInvoicesProducts(data)">Preview?</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a @click="downloadInvoice(data)">Download?</a>
                      </a-menu-item>
                      <!-- <a-menu-item v-if="user.isActive === true">
                                                <a @click="showDisableModal(user)">
                                                    Disable User?
                                                </a>
                                            </a-menu-item> -->
                      <!-- <a-menu-item v-if="user.isActive === false">
                                                <a @click="showChangePassword(user)"> Enable User?</a>
                                            </a-menu-item> -->
                    </a-menu>
                  </a-dropdown>
                </template>

                <template slot="status" slot-scope="data">
                  <status-component :status="data"></status-component>
                </template>
              </a-table>
            </a-col>
            <!-- <a-col :span="9" :offset="1">
            <div style="padding-top: 16px;background: #cbdeea;align-items: center;display: flex;justify-content: center;text-align: center;margin-bottom: 30px;border-radius: 6px;">
                                <p> <span><a-icon type="filter" /></span> Click to apply Filter</p>
                            </div>
            <div
              style="
                background: #fff;
                padding: 20px;
                border-radius: 6px;
                box-shadow: rgb(0 0 0 / 9%) 0px 2px 10px;
                margin-bottom: 30px;
              "
            >
              <div class="d-flex justify-content-between">
                <div style="font-size: 16px">Top Performing Products</div>
                <div style="font-size: 16px">
                  <a-select default-value="Customer" style="width: 120px">
                                                <a-select-option value="Customer">
                                                    Customer
                                                </a-select-option>
                                                <a-select-option value="Distribution Center">
                                                    Distribution Center
                                                </a-select-option>
                                                <a-select-option value="Order">
                                                    Order
                                                </a-select-option>
                                            </a-select>
                </div>
              </div>
              <div class="pb-3">
                                    <a style="font-size:14px;" href="#">Click to view reports</a>
                                </div>
              <div class="pb-3 pt-5">
                <div v-for="top in topPerformance" :key="top.key">
                  <item-stats :item="top"></item-stats>
                  <a-divider />
                </div>
              </div>
            </div>

            <div
              style="
                background: #fff;
                padding: 20px;
                border-radius: 6px;
                box-shadow: rgb(0 0 0 / 9%) 0px 2px 10px;
                margin-top: 30px;
              "
            >
              <div class="d-flex justify-content-between">
                <div style="font-size: 16px">Low Performing Products</div>
                <div style="font-size: 16px">
                  <a-select default-value="Customer" style="width: 120px">
                                                <a-select-option value="Customer">
                                                    Customer
                                                </a-select-option>
                                                <a-select-option value="Distribution Center">
                                                    Distribution Center
                                                </a-select-option>
                                                <a-select-option value="Order">
                                                    Order
                                                </a-select-option>
                                            </a-select>
                </div>
              </div>
              <div class="pb-3">
                                    <a style="font-size:14px;" href="#">Click to view reports</a>
                                </div>
              <div class="pb-3 pt-5">
                <div v-for="low in lowPerformance" :key="low.key">
                  <item-stats :item="low"></item-stats>
                  <a-divider />
                </div>
              </div>
            </div>
          </a-col> -->
          </a-row>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import _ from "lodash";
import XLSX from "xlsx";
// import ItemStats from "./common/ItemStats.vue";
import { NotificationMixins } from "@/mixins/NotificationMixins";

const columns = [
  //   {
  //     title: 'ID',
  //     // width: 150,
  //     key: 'id',
  //     dataIndex: 'id',
  //   },

  {
    title: "Product Name",
    dataIndex: "productBrandName",
    key: "productBrandName",
    scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.productBrandName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
    // width: 20,
  },
    {
      title: 'Category',
      dataIndex: 'productCategoryName',
      scopedSlots: {
      filterDropdown: 'filterCategoryDropdown',
      filterIcon: 'filterIcon',
      },
      onFilter: (value, record) =>
          record.productCategoryName
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
      // width: 200,
    },
    
    {
      title: 'Supplier',
      dataIndex: 'productSupplierName',
      scopedSlots: {
      filterDropdown: 'filterSupplierDropdown',
      filterIcon: 'filterIcon',
      },
      onFilter: (value, record) =>
          record.productSupplierName
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
      // width: 200,
    },
  {
    title: "Quantity",
    dataIndex: "totalQuantitySold",
    key: "totalQuantitySold",
    // width: 20,
  },

  {
    title: "Gross Sales",
    dataIndex: "totalSales",
    key: "totalSales",
    // width: 20,
  },
  {
    title: "Cost Of Goods",
    dataIndex: "totalCostPrice",
    key: "totalCostPrice",
    // width: 20,
  },
  {
    title: "Profits",
    dataIndex: "totalProfit",
    key: "totalProfit",
    // width: 20,
  },
  //   {
  //     title: 'Margin',
  //     dataIndex: 'margin',
  //     key: 'margin',
  //     // width: 150,
  //   },
  //   {
  //     title: 'Status',
  //     key: 'status',
  //     dataIndex: 'status',
  //     scopedSlots: { customRender: 'status' }
  //   },
  //   {
  //     title: 'Action',
  //     key: 'action',
  //     dataIndex: 'action',
  //     scopedSlots: { customRender: 'action' }
  //   },
];

const tableData = [
  {
    id: 1,
    // Key: 1,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
  {
    id: 2,
    // Key: 2,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
  {
    id: 3,
    // Key: 3,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
  {
    id: 4,
    // Key: 4,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
  {
    id: 5,
    // Key: 5,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
  {
    id: 6,
    // Key: 6,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
  {
    id: 7,
    // Key: 7,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
  {
    id: 8,
    // Key: 8,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
  {
    id: 9,
    // Key: 9,
    productBrandName: "Albendazole",
    // category: 'Dewormer',
    totalQuantitySold: "123",
    totalSales: "124.55",
    totalCostPrice: "124.55",
    totalProfit: "124.55",
    // margin: '5%'
  },
];

const customerData = [
  {
    id: 1,
    name: "Alhaji Enterprise",
    address: "Tamle",
    amount: 160990,
    rate: 9,
    status: "increase",
  },
  {
    id: 2,
    name: "Ali Enterprise",
    address: "Spintex",
    amount: 170990,
    rate: 9,
    status: "increase",
  },
  {
    id: 3,
    name: "VTP Enterprise",
    address: "Kasoa",
    amount: 160990,
    rate: 5,
    status: "decrease",
  },
];

export default {
  name: "Item",
  components: {
    // ItemStats,
  },
  mixins: [NotificationMixins],
  data() {
    return {
      tableData,
      tableLoading: false,
      customerData,
      dateFormat: "YYYY-MM-DD",
      columns,
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      startDate: moment().startOf('year'),
      endDate: moment(),
      productData: [],
      pagination: {
        pageSize: 20,
      },
      topPerformance: [],
      lowPerformance: [],
    };
  },
  methods: {
    ...mapActions(["getOverviewTopProducts"]),
    // async loadAllRetailers(){
    //     const response = await this.getAllRetailers();
    //     if(response.status === 200){
    //         this.availableRetailers = response.data.data;
    //     }else{
    //         console.log('Error | ', response)
    //     }
    // },
    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.searchText = selectedKeys[0];
        this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
        clearFilters();
        this.searchText = '';
        this.loadClientProductSales()
    },
    onCategoryChange(dateString){
        this.startDate = dateString[0];
        this.endDate = dateString[1];
        this.loadClientProductSales()
    },
    showSuccessAlert(message) {
      this.$notification["success"]({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification["error"]({
        message: message,
      });
    },
    exportExcell() {
      // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
      const dataToExport = [
        [
          "Product Name",
          "Category",
          "Supplier",
          "Quantity",
          "Gross Sales",
          "Cost Of Goods",
          "Profits",
        ],
      ];

      this.productData.forEach((v) => {
        dataToExport.push([
          v.productBrandName,
          v.productCategoryName,
          v.productSupplierName,
          v.totalQuantitySold,
          v.totalSales,
          v.totalCostPrice,
          v.totalProfit,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Sales-Item-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    getTopPeformance(products) {
      // first 3 items in tha array
      this.topPerformance = products.slice(0, 3).map((product) => ({
        key: product.key,
        productBrandName: product.productBrandName,
        totalQuantitySold: product.totalQuantitySold,
        totalSales: product.totalSales,
      }));
    },
    geLowPeformance(products) {
      // last 3 items in tha array
      this.lowPerformance = products.slice(-3).map((product) => ({
        key: product.key,
        productBrandName: product.productBrandName,
        totalQuantitySold: product.totalQuantitySold,
        totalSales: product.totalSales,
      }));
    },
    async loadClientProductSales() {
      this.tableLoading = true;
      let req_data = {
        startDate: this.startDate,
        endDate: this.endDate,
      };

      const response = await this.getOverviewTopProducts(req_data);
      this.tableLoading = false;
      if (response.status === 200) {
        let productList = response.data.data.map((productItem) => ({
          key: productItem.productId,
          productBrandName: productItem.productBrandName
            ? productItem.productBrandName
            : "N/A",
          productCategoryName: productItem.productCategoryName
          ? productItem.productCategoryName
          : "N/A",
          productSupplierName: productItem.productSupplierName
          ? productItem.productSupplierName
          : "N/A",
          totalQuantitySold: productItem.totalQuantitySold
            ? productItem.totalQuantitySold
            : 0,
          totalSales: productItem.totalSales ? productItem.totalSales : 0.0,
          totalCostPrice: productItem.totalCostPrice
            ? productItem.totalCostPrice
            : 0.0,
          totalProfit: productItem.totalProfit ? productItem.totalProfit : 0.0,
        }));

        productList = _.orderBy(productList, ["totalSales"], ["desc"]);
        this.getTopPeformance(productList);
        this.geLowPeformance(productList);
        this.productData = productList.map((item) => ({
          key: item.key,
          productBrandName: item.productBrandName,
          productCategoryName: item.productCategoryName,
          productSupplierName: item.productSupplierName,
          totalQuantitySold: item.totalQuantitySold.toLocaleString(undefined, {
            minimumFractionDigits: 0,
          }),
          totalSales: item.totalSales.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
          totalCostPrice: item.totalCostPrice.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
          totalProfit: item.totalProfit.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
        }));
      } else {
        console.log("Error | ", response);
      }
    },
  },
  computed: {},
  created() {
    if (this.loadClientProductSales) {
      this.loadClientProductSales();
    }
  },
};
</script>

<style scoped>
.requestActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.actions {
  display: flex;
  justify-content: space-between;
}

.card-container {
  background: none;
  overflow: hidden;
  height: 100vh;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container
  >>> .ant-tabs.ant-tabs-card
  .ant-tabs-card-bar
  .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}
.card-container >>> .ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
  border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
  border-top: none;
}
.modalStyle {
  display: flex;
  justify-content: center;
}

.card-container >>> .ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.spinner >>> .ant-spin-dot-item {
  background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

button:hover {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}
.orderTable >>> .ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
  color: #fff;
}
.orderTable >>> .ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableFixHead {
  overflow-y: auto;
  height: 200px;
}
.tableFixHead thead th {
  position: sticky;
  top: 0;
}
.tableFixHead table {
  border-collapse: collapse;
  width: 100%;
}
.tableFixHead th,
.tableFixHead td {
  padding: 8px 16px;
  border: 1px solid #ccc;
}
.tableFixHead th {
  background: #eee;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>